<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_VID_PRODUCTION_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label>Вид промышленной продукции:</label>
      </p>
      <select
        v-model="$parent.project.UF_VID_PRODUCTION_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="changeVidProduction()"
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in getListPromProduct()"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
          v-show="
            $parent.$parent.getProgramCode() !== 'auto_components' ||
              ($parent.$parent.getProgramCode() === 'auto_components' &&
                (item.ID == 827 || item.ID == 843))
          "
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_VID_PRODUCTION_ID"
          )
        }}
      </div>
    </div>
    <div
      class="col-xs-12 mycol content-mb-14"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_N_PRODUCTION_ID'
        )
      }"
    >
      <p class="content-s-2-label">
        <label v-if="$parent.$parent.getProgramCode() == 'auto_components'"
          >Наименование товара:</label
        >
        <label v-else>Наименование продукции:</label>
      </p>
      <!-- <select
        v-model="$parent.project.UF_N_PRODUCTION_ID"
        class="sel-dropdown i-main-style i-wid-29"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_N_PRODUCTION_ID')
        "
        :disabled="$parent.$parent.projectDisabled"
      >
        <option value=""></option>
        <option
          v-for="item in vidPodclass"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-text="item.NAME"
        ></option>
      </select> -->

      <multiselect
        class="i-main-style i-wid-50 stl-bs_bb multiselect-filter-project-register multiselect-multiline"
        label="LABEL"
        :limit="1"
        :limitText="filterItemText"
        track-by="ID"
        v-model="$parent.project.UF_N_PRODUCTION_ID_ARR"
        :options="vidPodclass"
        :multiple="false"
        placeholder
        :disabled="$parent.$parent.projectDisabled ? true : false"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_N_PRODUCTION_ID')
        "
      >
        <span slot="noOptions"
          >Выберите отраслевой перечень, куда включена Ваша продукция для
          обновления списка шифров продукции</span
        >
      </multiselect>

      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_N_PRODUCTION_ID"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "PromProducts",
  components: { Multiselect },
  computed: {
    vidPodclass() {
      if (this.$parent.project.UF_VID_PRODUCTION_ID < 1) {
        return [];
      }

      let versionListNum =
        this.$parent.project.UF_SETTING.VERSION_PRODUCT_PP719 > 0
          ? this.$parent.project.UF_SETTING.VERSION_PRODUCT_PP719
          : 3;

      let t = this.$parent.directory.tree_vid_prom_products.filter(
        c => c.ID === this.$parent.project.UF_VID_PRODUCTION_ID
      );

      if (t.length > 0) {
        let childs = t[0].CHILD;
        let returnList = [];

        if (versionListNum > 3) {
          childs.forEach(function(el) {
            if (this.inArray(versionListNum, el.UF_VERSIONS)) {
              returnList.push(el);
            }
          }, this);
        } else {
          childs.forEach(function(el) {
            if (
              this.inArray(2, el.UF_VERSIONS) ||
              this.inArray(3, el.UF_VERSIONS)
            ) {
              returnList.push(el);
            }
          }, this);
        }

        return returnList; //t[0].CHILD;
      }

      return [];
    }
  },
  methods: {
    inArray(needle, haystack) {
      var length = haystack.length;
      for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
      }
      return false;
    },
    getListPromProduct() {
      let returnList = [];

      let versionListNum =
        this.$parent.project.UF_SETTING.VERSION_PRODUCT_PP719 > 0
          ? this.$parent.project.UF_SETTING.VERSION_PRODUCT_PP719
          : 3;

      if (versionListNum > 3) {
        this.$parent.directory.tree_vid_prom_products.forEach(function(el) {
          if (this.inArray(versionListNum, el.UF_VERSIONS)) {
            returnList.push(el);
          }
        }, this);
      } else {
        //returnList = this.$parent.directory.tree_vid_prom_products;
        this.$parent.directory.tree_vid_prom_products.forEach(function(el) {
          if (
            this.inArray(2, el.UF_VERSIONS) ||
            this.inArray(3, el.UF_VERSIONS)
          ) {
            returnList.push(el);
          }
        }, this);
      }

      return returnList;
    },
    changeVidProduction() {
      this.$parent.project.UF_N_PRODUCTION_ID = "";
      this.$parent.project.UF_N_PRODUCTION_ID_ARR = [];
      this.$parent.$parent.removeError(
        "PROJECTS",
        "LOGIC",
        "UF_VID_PRODUCTION_ID"
      );
    }
  }
};
</script>

<style scoped></style>
